import React from "react";
import { useLanguage } from "@/i18n/LanguageContext";
import { supportedLanguages } from "@/i18n/translations";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Globe } from "lucide-react";
import { cn } from "@/lib/utils";

const labels = { lv: "Latviski", en: "English", ru: "Русский" };
const short = { lv: "LV", en: "EN", ru: "RU" };

export const LanguageSwitcher = ({ variant = "default" }) => {
  const { lang, setLang } = useLanguage();
  const isLight = variant === "light";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="lang-switcher-trigger"
        className={cn(
          "inline-flex items-center gap-2 px-3 py-2 text-xs uppercase tracking-[0.18em] transition-colors border",
          isLight
            ? "text-white/95 hover:text-white border-white/30 hover:bg-white/10"
            : "text-foreground/70 hover:text-foreground border-border/70 hover:bg-muted"
        )}
        aria-label="Language switcher"
      >
        <Globe className="h-3.5 w-3.5" strokeWidth={1.5} />
        <span>{short[lang]}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[10rem] rounded-none border-border">
        {supportedLanguages.map((code) => (
          <DropdownMenuItem
            key={code}
            data-testid={`lang-option-${code}`}
            onSelect={() => setLang(code)}
            className={cn(
              "cursor-pointer rounded-none text-sm tracking-wide font-sans",
              lang === code && "bg-secondary"
            )}
          >
            <span className="mr-2 text-xs uppercase tracking-[0.18em] text-primary/80">
              {short[code]}
            </span>
            <span className="text-foreground/80">{labels[code]}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
